<template>
    <div>
        <vs-tabs :value="active">
            <Table
                :draw="draw">
            </Table>
        </vs-tabs>
    </div>
</template>
<script>

import Table from "./component/tableExport.vue";
export default {
    components: {
        Table,
    },
    data() {
        return {
            
        }
    },
    methods: {
        handleFilter() {
            this.draw++;
        },
    },
    watch: {

    }
}
</script>
